import { Component, OnInit,Renderer, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs/Observable";
import { CanComponentDeactivate, CanDeactivateGuardService } from "../shared/modals/modal-popup/can-deactivate-gaurd.service";
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';
import { BootstrapDatePickerComponent } from '../shared/components/ng-date-picker.component';
import { EDIT_BTN, AssessmentSummary, DateUtility, SINGLE_ROW_HEADER, DELETE_BTN, AUDIT_BTN, AUDIT_ENTITY_ID, AUDIT_ENTITY_TYPE, AUDIT_ENTITY_COLUMN_DEFS, AUDIT_PAGE_TITLE, AgGridUtility, WpEtEnrollment } from '../shared';
import { CommonUtility, ServerConstantsService, DataService, APP_DATE_FORMAT } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import * as $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';
import { NumericEditorComponent } from "../shared/components/numeric-editor.component";

@Component({
  selector: 'app-test-score',
  templateUrl: './test-score.component.html',
  styleUrls: ['./test-score.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class TestScoreComponent implements OnInit, CanComponentDeactivate {
  @ViewChild('headerText') headerText:ElementRef;
  AUDIT_ENTITY_ID: string = AUDIT_ENTITY_ID;
  AUDIT_ENTITY_COLUMN_DEFS: string = AUDIT_ENTITY_COLUMN_DEFS;
  AUDIT_ENTITY_TYPE: string = AUDIT_ENTITY_TYPE;
  AUDIT_PAGE_TITLE: string = AUDIT_PAGE_TITLE;
  isDisabled = false;
  testsSw: String;
  tabIndex:any = "-1";
  isTests = false;
  tests: TestAndScore[] = [];
  testTypeDescJson: any;
  testTypeDescReverseJson: any;
  columnDefs: any;
  auditColumnDefs: any;
  testContext: any;
  testArray = [];
  removedTest: TestAndScore[] = [];
  userFullName;
  rowSelection;
  assessmentId;
  context;
  gridApi;
  gridColumnApi;
  assessment: AssessmentSummary;
  userActionNotificationsMap: any;
  components;
  defaultColDef;
  editType;
  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER;
  frameworkComponents;
  isCurrentEnrollment:Boolean = false;
  serverConstants: any;
  sharedData: any;

  validationError = [];
  showError = false;
  isShowStyle = false;
  etEnrollment:WpEtEnrollment;
  isChangeDetected=false;
  readOnly = false;
  tabToNextCell:any;

  constructor(

    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtil: DateUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    if(this.dataService.getSharedDataObject().get('ASMNT') == undefined){
      this.router.navigate(['/task']);
    }

  }

  ngOnInit() {
    this.dataService.globalAccess = false;
    this.readOnly = this.dataService.getSharedDataObject().get("ASMNT").innerNavPages.find(x=> x.pageId === 'ASMTS').readOnly;
    const userActionNotifications = this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS');
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(userActionNotifications);

    const testTypeDesc = this.data.getValueFromSharedDataMap('TestTypeDesc');
    testTypeDesc.forEach(element => {
      this.testArray.push(element.name);
    });
    this.testTypeDescJson = this.commonUtil.createNativeMapFromList(testTypeDesc);
    this.testTypeDescReverseJson = this.commonUtil.createReverseNativeMapFromList(testTypeDesc);

    // Shared object access to get personId and assessmentId
    const sharedData = this.dataService.getSharedDataObject();

    if (sharedData.get('assessmentId') !== null && sharedData.get('assessmentId') !== undefined) {
      this.assessmentId = Number(sharedData.get('assessmentId'));
    }

    if (sharedData.get('etEnrollment') !== null && sharedData.get('etEnrollment') !== undefined) {
      this.etEnrollment = sharedData.get('etEnrollment');
    }

    this.getColumnDefinitions();
    this.getAuditColumnDefinitions();


    if (this.assessmentId > 0) {
      const request = new RequestLoad(this.assessmentId);
      this.load(request);

    }

    if (sharedData.get('selectedEnrollmentEndDt') !== null && sharedData.get('selectedEnrollmentEndDt') !== undefined
     && sharedData.get('selectedEnrollmentEndDt') !== "Current") {
      this.isCurrentEnrollment = false;
    } else {
      this.isCurrentEnrollment = true
    }

    console.log('isDisabled : ' + this.isDisabled);
    console.log('readOnly : ' + this.readOnly);
    console.log('isCurrentEnrollment : ' + this.isCurrentEnrollment);
    console.log('selectedEnrollmentEndDt : ' + sharedData.get('selectedEnrollmentEndDt'));
    
  }
  focusing(event){
    if(!event.shiftKey && event.keyCode==9){
      event.preventDefault();
    setTimeout(() => this.headerText.nativeElement.focus(), 0);
    this.headerText.nativeElement.click();
    }
  }

  radioTestAndScore() {
    if (this.testsSw === 'Y') {
      this.isTests = true;
    } else {
      this.isTests = false;
    }
  }

  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Test', field: 'testCd', editable: !(this.isDisabled || this.readOnly), cellEditor: "agSelectCellEditor",
        cellEditorParams: {
          values: this.testArray,

        }, cellStyle: function (params) {
          if (params.api !== null) {
            const that = params.api.gridCore.gridOptions.context.component;
            if (that.isShowStyle && params.value === 'Pick an option') {
              return { border: '1px solid red' };
            } else {
              return { border: 'none' };
            }
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      {
        headerName: 'Score', field: 'score', width: 150, cellEditor: "numericEditor", editable: !(this.isDisabled || this.readOnly), cellStyle: function (params) {
          if (params.api !== null) {
            const that = params.api.gridCore.gridOptions.context.component;
            if (that.isShowStyle && params.value === undefined) {
              return { border: '1px solid red' };
            } else {
              return { border: 'none' };
            }
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      {
        headerName: 'Date Received', width: 140, field: 'receivedDt', editable: !(this.isDisabled || this.readOnly), cellEditor: "datePicker", cellStyle: function (params) {
          if (params.api !== null) {
            const that = params.api.gridCore.gridOptions.context.component;
            if (params.value === undefined || params.value.trim().length === 0 ||
              that.dateUtil.compareDate(params.value, new Date()) === 1) {

              return { border: '1px solid red' };

            } else {
              return { border: 'none' };
            }
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      { headerName: 'Action', width: 110, field: '', cellRenderer: this.getActionButtons ,
      suppressFilter: true,
      suppressSorting: true},
    ];

    this.context = {
      component: this,
    };
    this.rowSelection = "multiple";
    // this.components = { datePicker: this.getDatePicker() };
    this.frameworkComponents = {
      datePicker: BootstrapDatePickerComponent,
      numericEditor: NumericEditorComponent
    };
    this.tabToNextCell = function tabToNextCell(params) {
      var nextCell = params.nextCellDef;
      if(nextCell.column.colDef.headerName === "Action"){
        return;
      }
      else{
        return nextCell;
      }
    }
  }

  getAuditColumnDefinitions() {
    this.auditColumnDefs = [
      {
        headerName: 'Modified By',
        field: 'createdBy',
        width: 195,
        tooltipField: 'createdBy'
      },
      {
        headerName: 'Modified Date',
        field: 'createdDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        width: 160,
        tooltip: this.agGridUtility.formatTimeDateToDateTime
      },
      {
        headerName: 'Test',
        field: 'testCd',
        refData: this.testTypeDescJson,
        width: 160,
        tooltip: (params) => {
          const testTypeDescMap = params.context.testTypeDescJson;
          const testTypeCode = params.data.testCd;
          const testType = testTypeDescMap[testTypeCode];
          return testType;
        }
      },
      {
        headerName: 'Score',
        field: 'score',
        width: 160,
        tooltipField: 'score'
      },
      {
        headerName: 'Date Received',
        field: 'receivedDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        width: 160,
        tooltip: this.agGridUtility.formatTimeDateToDate
      }
    ];
  }

  getDatePicker() {


    function Datepicker() { }
    Datepicker.prototype.init = function (params) {
      this.eInput = document.createElement("input");
      this.eInput.value = params.value;

      ($(this.eInput) as any).datepicker({ maxDate: new Date, dateFormat: "mm/dd/yy" });
    };
    Datepicker.prototype.getGui = function () {
      return this.eInput;
    };
    Datepicker.prototype.afterGuiAttached = function () {
      this.eInput.focus();
      this.eInput.select();
    };
    Datepicker.prototype.getValue = function () {
      return this.eInput.value;
    };
    Datepicker.prototype.destroy = function () { };
    Datepicker.prototype.isPopup = function () {
      return false;
    };
    return Datepicker;
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();

  }

  onResize(event) {
    if(window.screen.width >= window.innerWidth){
      this.gridApi.columnDefs = this.columnDefs;
    }
    else{
      this.gridApi.sizeColumnsToFit();
    }
  }

  getActionButtons(params) {
    const that = params.context.component;

    const divRow = document.createElement('div');
    divRow.setAttribute("class", "row");

    const element = document.createElement('a');
    if (that.isDisabled || that.readOnly) {
      element.setAttribute("class", "disabled");
    }
    const image = DELETE_BTN;
    element.innerHTML = image;
    element.addEventListener('click', () => {
      that.deleteTest()
    });
    element.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32){
        that.deleteTest();
      }
      else if(event.keyCode == 9){
        event.preventDefault();
        setTimeout(() => auditElement.focus(), 0);
      }

    });
    element.setAttribute("tabindex", "0");

    const divCol1 = document.createElement('div');
    divCol1.setAttribute("class", "col-2 right-margin-1");

    divCol1.appendChild(element);

    //Audit Button
    const auditElement = document.createElement('a');
    const auditImage = AUDIT_BTN;
    auditElement.innerHTML = auditImage;
    auditElement.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.AssessmentTestScore');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Tests & Scores Audit');
      that.router.navigate(['/task/assessmentSummary/auditHistory'])
    });
    auditElement.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32){
        that.dataService.addValueToSharedDataMap('component', params.context.component);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.AssessmentTestScore');
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
        that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Tests & Scores Audit');
        that.router.navigate(['/task/assessmentSummary/auditHistory'])
      }

    });
    auditElement.setAttribute("tabindex", "0");

    const divCol2 = document.createElement('div');
    divCol2.setAttribute("class", "col-1");
    divCol2.appendChild(auditElement);
    divRow.appendChild(divCol1);
    divRow.appendChild(divCol2);

    return divRow;
  }
  dataChanges() {
    this.isChangeDetected = true;
  }
  addEventListenerToSearch(event){
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if(event.keyCode !== tabKeyCode) {
      return;
    }
    if(this.tests.length === 0){
      return;
    }

    if(event.shiftKey){
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }
  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
}

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if(this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  };

  saveAll() {
    setTimeout(() => this.headerText.nativeElement.focus(), 0);
    this.headerText.nativeElement.click();
    this.isChangeDetected = false;
    let alltest = []
    const dateReceivedArray=[];
    if (this.gridApi !== undefined) {
      this.gridApi.stopEditing();
      this.isShowStyle = true;
      this.gridApi.redrawRows();
      this.isShowStyle = false;

      this.gridApi.selectAll();
      alltest = this.gridApi.getSelectedRows();
      this.gridApi.deselectAll();


      //Validation Code
      this.validationError = [];
      this.showError = false;
      let errorIndex = 0;
      let isHeaderPushed = false;
      alltest.forEach(selectedRow => {
        ++errorIndex;
        let errorText = "";
        if (selectedRow.testCd === undefined || selectedRow.testCd === "Pick an option") {
          errorText = "Test, ";
        } if (selectedRow.score === undefined) {
          errorText = errorText + "Score, ";
        } if (selectedRow.receivedDt === undefined || selectedRow.receivedDt === '') {
          errorText = errorText + "Score, ";
        }
        else if (this.dateUtil.compareDate(selectedRow.receivedDt, new Date()) === 1 ||
        this.dateUtil.compareDate(selectedRow.receivedDt, this.etEnrollment.referredDt) === -1) {
          this.validationError.push("Row " + errorIndex + ": " + "Date Received should be in between referral date to current date and referral date is "+this.etEnrollment.referredDt);
          this.showError = true;
        }
        // else if (this.dateUtil.compareDate(selectedRow.receivedDt, this.etEnrollment.referredDt) !== -1) {
        //   this.validationError.push("Row " + errorIndex + ": " + "Date Received should be before refferral date "+this.etEnrollment.referredDt);
        //   this.showError = true;
        // }
        if (errorText.length > 0) {
          if (!isHeaderPushed) {
            isHeaderPushed = true;
            this.validationError.push("Following fields are mandatory:");
          }

          errorText = errorText.substring(0, errorText.length - 2);
          this.validationError.push("Row " + errorIndex + ": " + errorText);
          this.showError = true;
        }



          if(dateReceivedArray.includes(selectedRow.receivedDt+selectedRow.testCd))
          {
            this.validationError.push("Row " + errorIndex + ": " + "Date Received can't be same for more than one same Test");
          this.showError = true;
          }else{
            dateReceivedArray.push(selectedRow.receivedDt+selectedRow.testCd);
          }


      });

    }
    if (!this.showError) {
      this.removedTest.forEach(element => {
        alltest.push(element);
      });
      alltest.forEach(selectedRow => {
        selectedRow.testCd = this.testTypeDescReverseJson[selectedRow.testCd];
        selectedRow.receivedDt = this.dateUtil.convertFormattedDateForServer(selectedRow.receivedDt);
      });
      this.assessment.testScoreSw = this.testsSw;
      const request = new RequestLoadAll(alltest, this.assessment);
      if (this.testsSw === 'N' || (this.testsSw === 'Y' && (alltest.length > 0))) {

        this.http.post<RequestLoadAll>(this.serverConstants.SERVER_API_URL + '/assessment-summary/saveTest', request).subscribe(
          (data) => {
            if (data.hasOwnProperty('errorCode')) {
              this.notificationService.error('Assessment-Tests & Score', this.userActionNotificationsMap.ERROR);
            } else {
              this.isChangeDetected = false;
              this.notificationService.success('Assessment-Tests & Score', this.userActionNotificationsMap.ADD);
              if (this.assessmentId > 0) {

                this.load(new RequestLoad(this.assessmentId));
                this.removedTest = [];

              }
            }
          }, response => {

            this.notificationService.error('Assessment-Tests & Score', this.userActionNotificationsMap.ERROR);
          }, () => {

          });
      } else {
        this.notificationService.warn('Assessment-Tests & Score', "Please add atleast one Test & Score record");
      }
    }

  }


  load(request) {
    this.http.post<RequestLoadAll>(this.serverConstants.SERVER_API_URL + '/assessment-summary/loadObjects/test-score', request).subscribe(
      (data) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Assessment-Tests & Score', this.userActionNotificationsMap.ERROR);
        } else {
          if (data !== null && data !== undefined) {
            this.tests = data.tests;
            this.tests.forEach(selectedRow => {
              selectedRow.testCd = this.testTypeDescJson[selectedRow.testCd];
              selectedRow.receivedDt = this.dateUtil.convertFormattedDateFromServer(selectedRow.receivedDt);
            });

            this.assessment = data.assessment;
            if (this.assessment !== undefined) {

              // 19_02 test and scores should be editable all the time
              // Ticket 50784:DCO - SNAP Works - SIT Defect -Assessments - Not able to edit fix
              if (this.assessment.statusCd === undefined || this.assessment.statusCd === 'CN') {
                 this.isDisabled = true;
              }
              if (this.assessment.statusCd !== undefined && (this.assessment.statusCd === 'CO') || (this.assessment.statusCd === 'CN')) {
                // this.isDisabled = true;
                this.tabIndex = "0";
                this.getColumnDefinitions();
              }
              this.testsSw = this.assessment.testScoreSw;
              if (this.testsSw === 'Y') {
                this.isTests = true;
              } else {
                this.isTests = false;
              }
            }

          } else {
            this.tests = [];

          }

          this.validationError=[];
          this.showError=false;
        }
      }, response => {

        this.notificationService.error('Assessment-Tests & Score', this.userActionNotificationsMap.ERROR);
      }, () => {

      });
  }
  reset() {
    if (this.assessmentId > 0) {

      this.load(new RequestLoad(this.assessmentId));

    }
  }

  addTests() {
    const response = this.gridApi.updateRowData({ add: [new TestAndScore(this.assessment, 'N', this.userFullName, this.dateUtil.getFormattedSystemDateFromModel())] });
    let index;
    response.add.forEach(element => {
      index = element.rowIndex;
    });
    this.gridApi.setFocusedCell(index, "testCd");
    this.gridApi.startEditingCell({
      rowIndex: index,
      colKey: "testCd"
    });
    this.gridApi.paginationGoToPage( Math.floor(index / 10) );
  }
  deleteTest() {
    const selectedData = this.gridApi.getSelectedRows();
    this.gridApi.updateRowData({ remove: selectedData });

    selectedData.forEach(element => {
      if (element.id > 0) {
        element.deleteSw = 'Y';
        this.removedTest.push(element);
      }

    })
  }


}


class RequestLoad {
  constructor(
    public id: Number,

  ) {
  }
}

class TestAndScore {
  constructor(
    public assessment: AssessmentSummary,
    public deleteSw: String,
    public createdUser: String,
    public receivedDt?: any,
    public testCd?: string,
    public score?: number,
    public id?: any,
    public recordVersion?: number

  ) {
  }
}


class RequestLoadAll {
  constructor(
    public tests: any,
    public assessment: AssessmentSummary,
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/test-score/test-score.component.ts